export default [
  {
    id: 241900492,
    node_id: "MDEwOlJlcG9zaXRvcnkyNDE5MDA0OTI=",
    name: "animated-guide-vue3",
    full_name: "sdras/animated-guide-vue3",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/animated-guide-vue3",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/sdras/animated-guide-vue3",
    forks_url: "https://api.github.com/repos/sdras/animated-guide-vue3/forks",
    keys_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/animated-guide-vue3/teams",
    hooks_url: "https://api.github.com/repos/sdras/animated-guide-vue3/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/animated-guide-vue3/events",
    assignees_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/animated-guide-vue3/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/animated-guide-vue3/merges",
    archive_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/animated-guide-vue3/deployments",
    created_at: "2020-02-20T14:09:31Z",
    updated_at: "2021-07-07T10:41:49Z",
    pushed_at: "2020-02-21T10:24:39Z",
    git_url: "git://github.com/sdras/animated-guide-vue3.git",
    ssh_url: "git@github.com:sdras/animated-guide-vue3.git",
    clone_url: "https://github.com/sdras/animated-guide-vue3.git",
    svn_url: "https://github.com/sdras/animated-guide-vue3",
    homepage: "",
    size: 5844,
    stargazers_count: 141,
    watchers_count: 141,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 11,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 11,
    open_issues: 0,
    watchers: 141,
    default_branch: "master",
  },
  {
    id: 115382152,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTUzODIxNTI=",
    name: "array-explorer",
    full_name: "sdras/array-explorer",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/array-explorer",
    description:
      "⚡️ A resource to help figure out what JavaScript array method would be best to use at any given time",
    fork: false,
    url: "https://api.github.com/repos/sdras/array-explorer",
    forks_url: "https://api.github.com/repos/sdras/array-explorer/forks",
    keys_url: "https://api.github.com/repos/sdras/array-explorer/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/array-explorer/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/array-explorer/teams",
    hooks_url: "https://api.github.com/repos/sdras/array-explorer/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/array-explorer/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/array-explorer/events",
    assignees_url:
      "https://api.github.com/repos/sdras/array-explorer/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/array-explorer/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/array-explorer/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/array-explorer/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/array-explorer/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/array-explorer/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/array-explorer/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/array-explorer/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/array-explorer/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/array-explorer/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/array-explorer/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/array-explorer/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/array-explorer/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/array-explorer/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/array-explorer/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/array-explorer/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/array-explorer/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/array-explorer/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/array-explorer/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/array-explorer/merges",
    archive_url:
      "https://api.github.com/repos/sdras/array-explorer/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/array-explorer/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/array-explorer/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/array-explorer/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/array-explorer/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/array-explorer/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/array-explorer/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/array-explorer/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/array-explorer/deployments",
    created_at: "2017-12-26T03:30:38Z",
    updated_at: "2021-07-23T13:02:22Z",
    pushed_at: "2021-06-28T18:37:28Z",
    git_url: "git://github.com/sdras/array-explorer.git",
    ssh_url: "git@github.com:sdras/array-explorer.git",
    clone_url: "https://github.com/sdras/array-explorer.git",
    svn_url: "https://github.com/sdras/array-explorer",
    homepage: "https://arrayexplorer.netlify.com/",
    size: 4256,
    stargazers_count: 2458,
    watchers_count: 2458,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 237,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 20,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 237,
    open_issues: 20,
    watchers: 2458,
    default_branch: "main",
  },
  {
    id: 226587442,
    node_id: "MDEwOlJlcG9zaXRvcnkyMjY1ODc0NDI=",
    name: "awesome",
    full_name: "sdras/awesome",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/awesome",
    description: "😎 Awesome lists about all kinds of interesting topics",
    fork: true,
    url: "https://api.github.com/repos/sdras/awesome",
    forks_url: "https://api.github.com/repos/sdras/awesome/forks",
    keys_url: "https://api.github.com/repos/sdras/awesome/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/awesome/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/awesome/teams",
    hooks_url: "https://api.github.com/repos/sdras/awesome/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/awesome/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/awesome/events",
    assignees_url:
      "https://api.github.com/repos/sdras/awesome/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/awesome/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/awesome/tags",
    blobs_url: "https://api.github.com/repos/sdras/awesome/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/sdras/awesome/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/sdras/awesome/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/sdras/awesome/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/sdras/awesome/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/awesome/languages",
    stargazers_url: "https://api.github.com/repos/sdras/awesome/stargazers",
    contributors_url: "https://api.github.com/repos/sdras/awesome/contributors",
    subscribers_url: "https://api.github.com/repos/sdras/awesome/subscribers",
    subscription_url: "https://api.github.com/repos/sdras/awesome/subscription",
    commits_url: "https://api.github.com/repos/sdras/awesome/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/awesome/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/awesome/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/awesome/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/sdras/awesome/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/awesome/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/awesome/merges",
    archive_url:
      "https://api.github.com/repos/sdras/awesome/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/awesome/downloads",
    issues_url: "https://api.github.com/repos/sdras/awesome/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/awesome/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/awesome/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/awesome/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/awesome/labels{/name}",
    releases_url: "https://api.github.com/repos/sdras/awesome/releases{/id}",
    deployments_url: "https://api.github.com/repos/sdras/awesome/deployments",
    created_at: "2019-12-07T23:06:43Z",
    updated_at: "2021-07-07T10:41:53Z",
    pushed_at: "2019-12-07T23:12:27Z",
    git_url: "git://github.com/sdras/awesome.git",
    ssh_url: "git@github.com:sdras/awesome.git",
    clone_url: "https://github.com/sdras/awesome.git",
    svn_url: "https://github.com/sdras/awesome",
    homepage: "",
    size: 855,
    stargazers_count: 18,
    watchers_count: 18,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 11,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "cc0-1.0",
      name: "Creative Commons Zero v1.0 Universal",
      spdx_id: "CC0-1.0",
      url: "https://api.github.com/licenses/cc0-1.0",
      node_id: "MDc6TGljZW5zZTY=",
    },
    forks: 11,
    open_issues: 0,
    watchers: 18,
    default_branch: "master",
  },
  {
    id: 153500249,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTM1MDAyNDk=",
    name: "awesome-actions",
    full_name: "sdras/awesome-actions",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/awesome-actions",
    description: "A curated list of awesome actions to use on GitHub",
    fork: false,
    url: "https://api.github.com/repos/sdras/awesome-actions",
    forks_url: "https://api.github.com/repos/sdras/awesome-actions/forks",
    keys_url:
      "https://api.github.com/repos/sdras/awesome-actions/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/awesome-actions/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/awesome-actions/teams",
    hooks_url: "https://api.github.com/repos/sdras/awesome-actions/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/awesome-actions/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/awesome-actions/events",
    assignees_url:
      "https://api.github.com/repos/sdras/awesome-actions/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/awesome-actions/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/awesome-actions/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/awesome-actions/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/awesome-actions/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/awesome-actions/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/awesome-actions/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/awesome-actions/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/awesome-actions/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/awesome-actions/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/awesome-actions/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/awesome-actions/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/awesome-actions/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/awesome-actions/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/awesome-actions/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/awesome-actions/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/awesome-actions/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/awesome-actions/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/awesome-actions/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/awesome-actions/merges",
    archive_url:
      "https://api.github.com/repos/sdras/awesome-actions/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/awesome-actions/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/awesome-actions/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/awesome-actions/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/awesome-actions/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/awesome-actions/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/awesome-actions/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/awesome-actions/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/awesome-actions/deployments",
    created_at: "2018-10-17T17:53:45Z",
    updated_at: "2021-07-24T07:31:08Z",
    pushed_at: "2021-07-22T23:43:00Z",
    git_url: "git://github.com/sdras/awesome-actions.git",
    ssh_url: "git@github.com:sdras/awesome-actions.git",
    clone_url: "https://github.com/sdras/awesome-actions.git",
    svn_url: "https://github.com/sdras/awesome-actions",
    homepage: "",
    size: 1044,
    stargazers_count: 13653,
    watchers_count: 13653,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 917,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 58,
    license: {
      key: "cc0-1.0",
      name: "Creative Commons Zero v1.0 Universal",
      spdx_id: "CC0-1.0",
      url: "https://api.github.com/licenses/cc0-1.0",
      node_id: "MDc6TGljZW5zZTY=",
    },
    forks: 917,
    open_issues: 58,
    watchers: 13653,
    default_branch: "main",
  },
  {
    id: 130668902,
    node_id: "MDEwOlJlcG9zaXRvcnkxMzA2Njg5MDI=",
    name: "awesome-conference-practices",
    full_name: "sdras/awesome-conference-practices",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/awesome-conference-practices",
    description:
      "Did you like anything in particular about a conference? Let's make an awesome list 🎉",
    fork: true,
    url: "https://api.github.com/repos/sdras/awesome-conference-practices",
    forks_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/forks",
    keys_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/teams",
    hooks_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/events",
    assignees_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/merges",
    archive_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/awesome-conference-practices/deployments",
    created_at: "2018-04-23T08:58:11Z",
    updated_at: "2020-03-11T18:04:14Z",
    pushed_at: "2018-04-23T08:38:16Z",
    git_url: "git://github.com/sdras/awesome-conference-practices.git",
    ssh_url: "git@github.com:sdras/awesome-conference-practices.git",
    clone_url: "https://github.com/sdras/awesome-conference-practices.git",
    svn_url: "https://github.com/sdras/awesome-conference-practices",
    homepage: null,
    size: 64,
    stargazers_count: 7,
    watchers_count: 7,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 2,
    open_issues: 0,
    watchers: 7,
    default_branch: "master",
  },
  {
    id: 116068741,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTYwNjg3NDE=",
    name: "awesome-javascript",
    full_name: "sdras/awesome-javascript",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/awesome-javascript",
    description:
      "🐢 A collection of awesome browser-side  JavaScript libraries, resources and shiny things.",
    fork: true,
    url: "https://api.github.com/repos/sdras/awesome-javascript",
    forks_url: "https://api.github.com/repos/sdras/awesome-javascript/forks",
    keys_url:
      "https://api.github.com/repos/sdras/awesome-javascript/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/awesome-javascript/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/awesome-javascript/teams",
    hooks_url: "https://api.github.com/repos/sdras/awesome-javascript/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/awesome-javascript/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/awesome-javascript/events",
    assignees_url:
      "https://api.github.com/repos/sdras/awesome-javascript/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/awesome-javascript/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/awesome-javascript/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/awesome-javascript/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/awesome-javascript/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/awesome-javascript/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/awesome-javascript/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/awesome-javascript/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/awesome-javascript/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/awesome-javascript/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/awesome-javascript/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/awesome-javascript/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/awesome-javascript/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/awesome-javascript/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/awesome-javascript/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/awesome-javascript/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/awesome-javascript/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/awesome-javascript/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/awesome-javascript/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/awesome-javascript/merges",
    archive_url:
      "https://api.github.com/repos/sdras/awesome-javascript/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/awesome-javascript/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/awesome-javascript/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/awesome-javascript/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/awesome-javascript/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/awesome-javascript/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/awesome-javascript/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/awesome-javascript/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/awesome-javascript/deployments",
    created_at: "2018-01-02T23:39:26Z",
    updated_at: "2020-05-19T00:43:32Z",
    pushed_at: "2018-01-03T14:33:51Z",
    git_url: "git://github.com/sdras/awesome-javascript.git",
    ssh_url: "git@github.com:sdras/awesome-javascript.git",
    clone_url: "https://github.com/sdras/awesome-javascript.git",
    svn_url: "https://github.com/sdras/awesome-javascript",
    homepage: "",
    size: 588,
    stargazers_count: 44,
    watchers_count: 44,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 19,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 19,
    open_issues: 0,
    watchers: 44,
    default_branch: "master",
  },
  {
    id: 100179936,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDAxNzk5MzY=",
    name: "awesome-nuxt",
    full_name: "sdras/awesome-nuxt",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/awesome-nuxt",
    description: "A curated list of awesome things related to Nuxt.js",
    fork: true,
    url: "https://api.github.com/repos/sdras/awesome-nuxt",
    forks_url: "https://api.github.com/repos/sdras/awesome-nuxt/forks",
    keys_url: "https://api.github.com/repos/sdras/awesome-nuxt/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/awesome-nuxt/teams",
    hooks_url: "https://api.github.com/repos/sdras/awesome-nuxt/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/awesome-nuxt/events",
    assignees_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/awesome-nuxt/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/awesome-nuxt/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/awesome-nuxt/merges",
    archive_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/awesome-nuxt/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/awesome-nuxt/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/awesome-nuxt/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/awesome-nuxt/deployments",
    created_at: "2017-08-13T13:52:05Z",
    updated_at: "2021-06-16T17:16:00Z",
    pushed_at: "2017-08-13T13:55:58Z",
    git_url: "git://github.com/sdras/awesome-nuxt.git",
    ssh_url: "git@github.com:sdras/awesome-nuxt.git",
    clone_url: "https://github.com/sdras/awesome-nuxt.git",
    svn_url: "https://github.com/sdras/awesome-nuxt",
    homepage: "",
    size: 20,
    stargazers_count: 6,
    watchers_count: 6,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 2,
    open_issues: 0,
    watchers: 6,
    default_branch: "master",
  },
  {
    id: 97657280,
    node_id: "MDEwOlJlcG9zaXRvcnk5NzY1NzI4MA==",
    name: "awesome-vue",
    full_name: "sdras/awesome-vue",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/awesome-vue",
    description: "A curated list of awesome things related to Vue.js",
    fork: true,
    url: "https://api.github.com/repos/sdras/awesome-vue",
    forks_url: "https://api.github.com/repos/sdras/awesome-vue/forks",
    keys_url: "https://api.github.com/repos/sdras/awesome-vue/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/awesome-vue/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/awesome-vue/teams",
    hooks_url: "https://api.github.com/repos/sdras/awesome-vue/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/awesome-vue/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/awesome-vue/events",
    assignees_url:
      "https://api.github.com/repos/sdras/awesome-vue/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/awesome-vue/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/awesome-vue/tags",
    blobs_url: "https://api.github.com/repos/sdras/awesome-vue/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/awesome-vue/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/awesome-vue/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/sdras/awesome-vue/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/awesome-vue/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/awesome-vue/languages",
    stargazers_url: "https://api.github.com/repos/sdras/awesome-vue/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/awesome-vue/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/awesome-vue/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/awesome-vue/subscription",
    commits_url: "https://api.github.com/repos/sdras/awesome-vue/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/awesome-vue/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/awesome-vue/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/awesome-vue/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/awesome-vue/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/awesome-vue/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/awesome-vue/merges",
    archive_url:
      "https://api.github.com/repos/sdras/awesome-vue/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/awesome-vue/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/awesome-vue/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/awesome-vue/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/awesome-vue/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/awesome-vue/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/awesome-vue/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/awesome-vue/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/awesome-vue/deployments",
    created_at: "2017-07-19T00:59:54Z",
    updated_at: "2021-04-25T17:34:31Z",
    pushed_at: "2017-09-20T05:51:50Z",
    git_url: "git://github.com/sdras/awesome-vue.git",
    ssh_url: "git@github.com:sdras/awesome-vue.git",
    clone_url: "https://github.com/sdras/awesome-vue.git",
    svn_url: "https://github.com/sdras/awesome-vue",
    homepage: "",
    size: 1960,
    stargazers_count: 12,
    watchers_count: 12,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 3,
    open_issues: 0,
    watchers: 12,
    default_branch: "master",
  },
  {
    id: 113219461,
    node_id: "MDEwOlJlcG9zaXRvcnkxMTMyMTk0NjE=",
    name: "azure-functions-cli",
    full_name: "sdras/azure-functions-cli",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/azure-functions-cli",
    description: "Command line tool for Azure Function",
    fork: true,
    url: "https://api.github.com/repos/sdras/azure-functions-cli",
    forks_url: "https://api.github.com/repos/sdras/azure-functions-cli/forks",
    keys_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/azure-functions-cli/teams",
    hooks_url: "https://api.github.com/repos/sdras/azure-functions-cli/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/azure-functions-cli/events",
    assignees_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/azure-functions-cli/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/azure-functions-cli/merges",
    archive_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/azure-functions-cli/deployments",
    created_at: "2017-12-05T18:40:40Z",
    updated_at: "2017-12-05T18:40:41Z",
    pushed_at: "2017-12-06T21:43:09Z",
    git_url: "git://github.com/sdras/azure-functions-cli.git",
    ssh_url: "git@github.com:sdras/azure-functions-cli.git",
    clone_url: "https://github.com/sdras/azure-functions-cli.git",
    svn_url: "https://github.com/sdras/azure-functions-cli",
    homepage: null,
    size: 585,
    stargazers_count: 0,
    watchers_count: 0,
    language: "C#",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "other",
      name: "Other",
      spdx_id: "NOASSERTION",
      url: null,
      node_id: "MDc6TGljZW5zZTA=",
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 150788236,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTA3ODgyMzY=",
    name: "azure-functions-durable-extension",
    full_name: "sdras/azure-functions-durable-extension",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/azure-functions-durable-extension",
    description: "Durable Task Framework extension for Azure Functions",
    fork: true,
    url: "https://api.github.com/repos/sdras/azure-functions-durable-extension",
    forks_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/forks",
    keys_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/teams",
    hooks_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/events",
    assignees_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/merges",
    archive_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/azure-functions-durable-extension/deployments",
    created_at: "2018-09-28T19:52:09Z",
    updated_at: "2018-09-28T19:52:11Z",
    pushed_at: "2018-09-26T11:27:13Z",
    git_url: "git://github.com/sdras/azure-functions-durable-extension.git",
    ssh_url: "git@github.com:sdras/azure-functions-durable-extension.git",
    clone_url: "https://github.com/sdras/azure-functions-durable-extension.git",
    svn_url: "https://github.com/sdras/azure-functions-durable-extension",
    homepage: null,
    size: 9934,
    stargazers_count: 0,
    watchers_count: 0,
    language: "C#",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 25430428,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTQzMDQyOA==",
    name: "Benchmarking-Animations",
    full_name: "sdras/Benchmarking-Animations",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/Benchmarking-Animations",
    description:
      "Writing the same simple animation in a loop in SMIL, Canvas, CSS, and Velocity for benchmarking purposes.",
    fork: false,
    url: "https://api.github.com/repos/sdras/Benchmarking-Animations",
    forks_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/forks",
    keys_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/teams",
    hooks_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/events",
    assignees_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/Benchmarking-Animations/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/merges",
    archive_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/Benchmarking-Animations/deployments",
    created_at: "2014-10-19T15:08:05Z",
    updated_at: "2021-07-21T11:28:25Z",
    pushed_at: "2015-01-23T06:05:05Z",
    git_url: "git://github.com/sdras/Benchmarking-Animations.git",
    ssh_url: "git@github.com:sdras/Benchmarking-Animations.git",
    clone_url: "https://github.com/sdras/Benchmarking-Animations.git",
    svn_url: "https://github.com/sdras/Benchmarking-Animations",
    homepage: null,
    size: 214,
    stargazers_count: 7,
    watchers_count: 7,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 7,
    default_branch: "master",
  },
  {
    id: 285059448,
    node_id: "MDEwOlJlcG9zaXRvcnkyODUwNTk0NDg=",
    name: "building-web-apps-with-vue",
    full_name: "sdras/building-web-apps-with-vue",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/building-web-apps-with-vue",
    description: "building-web-app-with-vue",
    fork: false,
    url: "https://api.github.com/repos/sdras/building-web-apps-with-vue",
    forks_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/forks",
    keys_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/teams",
    hooks_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/events",
    assignees_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/merges",
    archive_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/building-web-apps-with-vue/deployments",
    created_at: "2020-08-04T18:03:35Z",
    updated_at: "2021-07-23T13:45:55Z",
    pushed_at: "2021-06-17T14:28:01Z",
    git_url: "git://github.com/sdras/building-web-apps-with-vue.git",
    ssh_url: "git@github.com:sdras/building-web-apps-with-vue.git",
    clone_url: "https://github.com/sdras/building-web-apps-with-vue.git",
    svn_url: "https://github.com/sdras/building-web-apps-with-vue",
    homepage: null,
    size: 13174,
    stargazers_count: 221,
    watchers_count: 221,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 89,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 68,
    license: null,
    forks: 89,
    open_issues: 68,
    watchers: 221,
    default_branch: "main",
  },
  {
    id: 355601088,
    node_id: "MDEwOlJlcG9zaXRvcnkzNTU2MDEwODg=",
    name: "career-ladders",
    full_name: "sdras/career-ladders",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/career-ladders",
    description:
      "A sample of career ladders I use for my organization, open sourced for anyone.",
    fork: false,
    url: "https://api.github.com/repos/sdras/career-ladders",
    forks_url: "https://api.github.com/repos/sdras/career-ladders/forks",
    keys_url: "https://api.github.com/repos/sdras/career-ladders/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/career-ladders/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/career-ladders/teams",
    hooks_url: "https://api.github.com/repos/sdras/career-ladders/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/career-ladders/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/career-ladders/events",
    assignees_url:
      "https://api.github.com/repos/sdras/career-ladders/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/career-ladders/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/career-ladders/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/career-ladders/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/career-ladders/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/career-ladders/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/career-ladders/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/career-ladders/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/career-ladders/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/career-ladders/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/career-ladders/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/career-ladders/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/career-ladders/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/career-ladders/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/career-ladders/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/career-ladders/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/career-ladders/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/career-ladders/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/career-ladders/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/career-ladders/merges",
    archive_url:
      "https://api.github.com/repos/sdras/career-ladders/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/career-ladders/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/career-ladders/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/career-ladders/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/career-ladders/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/career-ladders/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/career-ladders/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/career-ladders/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/career-ladders/deployments",
    created_at: "2021-04-07T15:48:54Z",
    updated_at: "2021-07-23T14:18:37Z",
    pushed_at: "2021-06-08T15:45:37Z",
    git_url: "git://github.com/sdras/career-ladders.git",
    ssh_url: "git@github.com:sdras/career-ladders.git",
    clone_url: "https://github.com/sdras/career-ladders.git",
    svn_url: "https://github.com/sdras/career-ladders",
    homepage: "https://career-ladders.dev/",
    size: 3684,
    stargazers_count: 530,
    watchers_count: 530,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 35,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 35,
    open_issues: 1,
    watchers: 530,
    default_branch: "main",
  },
  {
    id: 103750851,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDM3NTA4NTE=",
    name: "cda-locale",
    full_name: "sdras/cda-locale",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/cda-locale",
    description:
      "Showing Microsoft Cloud Developer Advocates speaking, 2017 and 2018",
    fork: false,
    url: "https://api.github.com/repos/sdras/cda-locale",
    forks_url: "https://api.github.com/repos/sdras/cda-locale/forks",
    keys_url: "https://api.github.com/repos/sdras/cda-locale/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/cda-locale/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/cda-locale/teams",
    hooks_url: "https://api.github.com/repos/sdras/cda-locale/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/cda-locale/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/cda-locale/events",
    assignees_url:
      "https://api.github.com/repos/sdras/cda-locale/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/cda-locale/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/cda-locale/tags",
    blobs_url: "https://api.github.com/repos/sdras/cda-locale/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/cda-locale/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/cda-locale/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/sdras/cda-locale/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/cda-locale/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/cda-locale/languages",
    stargazers_url: "https://api.github.com/repos/sdras/cda-locale/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/cda-locale/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/cda-locale/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/cda-locale/subscription",
    commits_url: "https://api.github.com/repos/sdras/cda-locale/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/cda-locale/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/cda-locale/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/cda-locale/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/cda-locale/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/cda-locale/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/cda-locale/merges",
    archive_url:
      "https://api.github.com/repos/sdras/cda-locale/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/cda-locale/downloads",
    issues_url: "https://api.github.com/repos/sdras/cda-locale/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/cda-locale/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/cda-locale/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/cda-locale/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/cda-locale/labels{/name}",
    releases_url: "https://api.github.com/repos/sdras/cda-locale/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/cda-locale/deployments",
    created_at: "2017-09-16T12:35:56Z",
    updated_at: "2021-06-21T09:07:12Z",
    pushed_at: "2018-01-14T18:59:54Z",
    git_url: "git://github.com/sdras/cda-locale.git",
    ssh_url: "git@github.com:sdras/cda-locale.git",
    clone_url: "https://github.com/sdras/cda-locale.git",
    svn_url: "https://github.com/sdras/cda-locale",
    homepage: "https://cda-locale.netlify.com/",
    size: 1415,
    stargazers_count: 101,
    watchers_count: 101,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 10,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 10,
    open_issues: 0,
    watchers: 101,
    default_branch: "master",
  },
  {
    id: 141358483,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDEzNTg0ODM=",
    name: "cda-tracker",
    full_name: "sdras/cda-tracker",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/cda-tracker",
    description: null,
    fork: true,
    url: "https://api.github.com/repos/sdras/cda-tracker",
    forks_url: "https://api.github.com/repos/sdras/cda-tracker/forks",
    keys_url: "https://api.github.com/repos/sdras/cda-tracker/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/cda-tracker/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/cda-tracker/teams",
    hooks_url: "https://api.github.com/repos/sdras/cda-tracker/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/cda-tracker/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/cda-tracker/events",
    assignees_url:
      "https://api.github.com/repos/sdras/cda-tracker/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/cda-tracker/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/cda-tracker/tags",
    blobs_url: "https://api.github.com/repos/sdras/cda-tracker/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/cda-tracker/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/cda-tracker/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/sdras/cda-tracker/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/cda-tracker/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/cda-tracker/languages",
    stargazers_url: "https://api.github.com/repos/sdras/cda-tracker/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/cda-tracker/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/cda-tracker/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/cda-tracker/subscription",
    commits_url: "https://api.github.com/repos/sdras/cda-tracker/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/cda-tracker/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/cda-tracker/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/cda-tracker/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/cda-tracker/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/cda-tracker/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/cda-tracker/merges",
    archive_url:
      "https://api.github.com/repos/sdras/cda-tracker/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/cda-tracker/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/cda-tracker/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/cda-tracker/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/cda-tracker/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/cda-tracker/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/cda-tracker/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/cda-tracker/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/cda-tracker/deployments",
    created_at: "2018-07-18T00:01:59Z",
    updated_at: "2018-07-18T00:15:41Z",
    pushed_at: "2018-07-18T00:15:40Z",
    git_url: "git://github.com/sdras/cda-tracker.git",
    ssh_url: "git@github.com:sdras/cda-tracker.git",
    clone_url: "https://github.com/sdras/cda-tracker.git",
    svn_url: "https://github.com/sdras/cda-tracker",
    homepage: null,
    size: 39,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 189795452,
    node_id: "MDEwOlJlcG9zaXRvcnkxODk3OTU0NTI=",
    name: "cli",
    full_name: "sdras/cli",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/cli",
    description: "Netlify command line tool",
    fork: true,
    url: "https://api.github.com/repos/sdras/cli",
    forks_url: "https://api.github.com/repos/sdras/cli/forks",
    keys_url: "https://api.github.com/repos/sdras/cli/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/cli/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/cli/teams",
    hooks_url: "https://api.github.com/repos/sdras/cli/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/cli/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/cli/events",
    assignees_url: "https://api.github.com/repos/sdras/cli/assignees{/user}",
    branches_url: "https://api.github.com/repos/sdras/cli/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/cli/tags",
    blobs_url: "https://api.github.com/repos/sdras/cli/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/sdras/cli/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/sdras/cli/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/sdras/cli/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/sdras/cli/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/cli/languages",
    stargazers_url: "https://api.github.com/repos/sdras/cli/stargazers",
    contributors_url: "https://api.github.com/repos/sdras/cli/contributors",
    subscribers_url: "https://api.github.com/repos/sdras/cli/subscribers",
    subscription_url: "https://api.github.com/repos/sdras/cli/subscription",
    commits_url: "https://api.github.com/repos/sdras/cli/commits{/sha}",
    git_commits_url: "https://api.github.com/repos/sdras/cli/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/sdras/cli/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/cli/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/sdras/cli/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/cli/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/cli/merges",
    archive_url:
      "https://api.github.com/repos/sdras/cli/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/cli/downloads",
    issues_url: "https://api.github.com/repos/sdras/cli/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/cli/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/cli/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/cli/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/cli/labels{/name}",
    releases_url: "https://api.github.com/repos/sdras/cli/releases{/id}",
    deployments_url: "https://api.github.com/repos/sdras/cli/deployments",
    created_at: "2019-06-02T02:10:32Z",
    updated_at: "2019-06-02T02:10:35Z",
    pushed_at: "2019-06-03T04:40:10Z",
    git_url: "git://github.com/sdras/cli.git",
    ssh_url: "git@github.com:sdras/cli.git",
    clone_url: "https://github.com/sdras/cli.git",
    svn_url: "https://github.com/sdras/cli",
    homepage: "https://www.netlify.com/docs/cli",
    size: 2062,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 255032668,
    node_id: "MDEwOlJlcG9zaXRvcnkyNTUwMzI2Njg=",
    name: "contentful-nuxt-netlify",
    full_name: "sdras/contentful-nuxt-netlify",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/contentful-nuxt-netlify",
    description: "Example setup for Contentful and Nuxt on Netlify",
    fork: false,
    url: "https://api.github.com/repos/sdras/contentful-nuxt-netlify",
    forks_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/forks",
    keys_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/teams",
    hooks_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/events",
    assignees_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/contentful-nuxt-netlify/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/merges",
    archive_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/contentful-nuxt-netlify/deployments",
    created_at: "2020-04-12T07:39:43Z",
    updated_at: "2021-07-22T01:15:24Z",
    pushed_at: "2021-06-17T02:03:09Z",
    git_url: "git://github.com/sdras/contentful-nuxt-netlify.git",
    ssh_url: "git@github.com:sdras/contentful-nuxt-netlify.git",
    clone_url: "https://github.com/sdras/contentful-nuxt-netlify.git",
    svn_url: "https://github.com/sdras/contentful-nuxt-netlify",
    homepage: "https://contentful-nuxt-example.netlify.com/",
    size: 1916,
    stargazers_count: 41,
    watchers_count: 41,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 13,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 12,
    license: null,
    forks: 13,
    open_issues: 12,
    watchers: 41,
    default_branch: "master",
  },
  {
    id: 188726142,
    node_id: "MDEwOlJlcG9zaXRvcnkxODg3MjYxNDI=",
    name: "cssgridgenerator",
    full_name: "sdras/cssgridgenerator",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/cssgridgenerator",
    description: "🧮 Generate basic CSS Grid code to make dynamic layouts!",
    fork: false,
    url: "https://api.github.com/repos/sdras/cssgridgenerator",
    forks_url: "https://api.github.com/repos/sdras/cssgridgenerator/forks",
    keys_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/cssgridgenerator/teams",
    hooks_url: "https://api.github.com/repos/sdras/cssgridgenerator/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/cssgridgenerator/events",
    assignees_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/cssgridgenerator/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/cssgridgenerator/merges",
    archive_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/cssgridgenerator/deployments",
    created_at: "2019-05-26T20:01:03Z",
    updated_at: "2021-07-23T09:18:30Z",
    pushed_at: "2021-05-27T12:30:23Z",
    git_url: "git://github.com/sdras/cssgridgenerator.git",
    ssh_url: "git@github.com:sdras/cssgridgenerator.git",
    clone_url: "https://github.com/sdras/cssgridgenerator.git",
    svn_url: "https://github.com/sdras/cssgridgenerator",
    homepage: "https://cssgrid-generator.netlify.com/",
    size: 3160,
    stargazers_count: 3731,
    watchers_count: 3731,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 346,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 19,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 346,
    open_issues: 19,
    watchers: 3731,
    default_branch: "main",
  },
  {
    id: 157916577,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTc5MTY1Nzc=",
    name: "d3-example-ignitetour",
    full_name: "sdras/d3-example-ignitetour",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/d3-example-ignitetour",
    description:
      " This repo serves as an example for Microsoft Ignite the Tour. In this session, we explore how to create basic charts and graphs using d3.",
    fork: false,
    url: "https://api.github.com/repos/sdras/d3-example-ignitetour",
    forks_url: "https://api.github.com/repos/sdras/d3-example-ignitetour/forks",
    keys_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/d3-example-ignitetour/teams",
    hooks_url: "https://api.github.com/repos/sdras/d3-example-ignitetour/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/events",
    assignees_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/d3-example-ignitetour/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/merges",
    archive_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/d3-example-ignitetour/deployments",
    created_at: "2018-11-16T20:12:36Z",
    updated_at: "2020-05-17T04:12:26Z",
    pushed_at: "2018-12-10T11:57:10Z",
    git_url: "git://github.com/sdras/d3-example-ignitetour.git",
    ssh_url: "git@github.com:sdras/d3-example-ignitetour.git",
    clone_url: "https://github.com/sdras/d3-example-ignitetour.git",
    svn_url: "https://github.com/sdras/d3-example-ignitetour",
    homepage: "",
    size: 139,
    stargazers_count: 21,
    watchers_count: 21,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 3,
    open_issues: 0,
    watchers: 21,
    default_branch: "master",
  },
  {
    id: 104523154,
    node_id: "MDEwOlJlcG9zaXRvcnkxMDQ1MjMxNTQ=",
    name: "data-in-motion",
    full_name: "sdras/data-in-motion",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/data-in-motion",
    description:
      "My talk about the importance of animation in data visualizations",
    fork: false,
    url: "https://api.github.com/repos/sdras/data-in-motion",
    forks_url: "https://api.github.com/repos/sdras/data-in-motion/forks",
    keys_url: "https://api.github.com/repos/sdras/data-in-motion/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/data-in-motion/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/data-in-motion/teams",
    hooks_url: "https://api.github.com/repos/sdras/data-in-motion/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/data-in-motion/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/data-in-motion/events",
    assignees_url:
      "https://api.github.com/repos/sdras/data-in-motion/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/data-in-motion/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/data-in-motion/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/data-in-motion/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/data-in-motion/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/data-in-motion/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/data-in-motion/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/data-in-motion/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/data-in-motion/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/data-in-motion/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/data-in-motion/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/data-in-motion/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/data-in-motion/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/data-in-motion/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/data-in-motion/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/data-in-motion/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/data-in-motion/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/data-in-motion/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/data-in-motion/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/data-in-motion/merges",
    archive_url:
      "https://api.github.com/repos/sdras/data-in-motion/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/data-in-motion/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/data-in-motion/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/data-in-motion/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/data-in-motion/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/data-in-motion/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/data-in-motion/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/data-in-motion/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/data-in-motion/deployments",
    created_at: "2017-09-22T22:15:41Z",
    updated_at: "2020-07-24T05:52:09Z",
    pushed_at: "2017-09-22T22:24:05Z",
    git_url: "git://github.com/sdras/data-in-motion.git",
    ssh_url: "git@github.com:sdras/data-in-motion.git",
    clone_url: "https://github.com/sdras/data-in-motion.git",
    svn_url: "https://github.com/sdras/data-in-motion",
    homepage: null,
    size: 467545,
    stargazers_count: 14,
    watchers_count: 14,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 1,
    open_issues: 0,
    watchers: 14,
    default_branch: "master",
  },
  {
    id: 149911333,
    node_id: "MDEwOlJlcG9zaXRvcnkxNDk5MTEzMzM=",
    name: "design-for-developers",
    full_name: "sdras/design-for-developers",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/design-for-developers",
    description: "Design for Developers Workshop",
    fork: false,
    url: "https://api.github.com/repos/sdras/design-for-developers",
    forks_url: "https://api.github.com/repos/sdras/design-for-developers/forks",
    keys_url:
      "https://api.github.com/repos/sdras/design-for-developers/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/design-for-developers/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/design-for-developers/teams",
    hooks_url: "https://api.github.com/repos/sdras/design-for-developers/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/design-for-developers/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/design-for-developers/events",
    assignees_url:
      "https://api.github.com/repos/sdras/design-for-developers/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/design-for-developers/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/design-for-developers/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/design-for-developers/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/design-for-developers/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/design-for-developers/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/design-for-developers/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/design-for-developers/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/design-for-developers/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/design-for-developers/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/design-for-developers/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/design-for-developers/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/design-for-developers/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/design-for-developers/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/design-for-developers/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/design-for-developers/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/design-for-developers/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/design-for-developers/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/design-for-developers/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/design-for-developers/merges",
    archive_url:
      "https://api.github.com/repos/sdras/design-for-developers/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/design-for-developers/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/design-for-developers/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/design-for-developers/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/design-for-developers/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/design-for-developers/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/design-for-developers/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/design-for-developers/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/design-for-developers/deployments",
    created_at: "2018-09-22T19:42:40Z",
    updated_at: "2021-07-19T05:12:40Z",
    pushed_at: "2019-01-15T00:44:00Z",
    git_url: "git://github.com/sdras/design-for-developers.git",
    ssh_url: "git@github.com:sdras/design-for-developers.git",
    clone_url: "https://github.com/sdras/design-for-developers.git",
    svn_url: "https://github.com/sdras/design-for-developers",
    homepage: "https://frontendmasters.com/courses/design-for-developers/",
    size: 74970,
    stargazers_count: 614,
    watchers_count: 614,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 129,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: null,
    forks: 129,
    open_issues: 1,
    watchers: 614,
    default_branch: "master",
  },
  {
    id: 260720499,
    node_id: "MDEwOlJlcG9zaXRvcnkyNjA3MjA0OTk=",
    name: "devex-utm-builder",
    full_name: "sdras/devex-utm-builder",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/devex-utm-builder",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/sdras/devex-utm-builder",
    forks_url: "https://api.github.com/repos/sdras/devex-utm-builder/forks",
    keys_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/devex-utm-builder/teams",
    hooks_url: "https://api.github.com/repos/sdras/devex-utm-builder/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/devex-utm-builder/events",
    assignees_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/devex-utm-builder/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/devex-utm-builder/merges",
    archive_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/devex-utm-builder/deployments",
    created_at: "2020-05-02T15:48:18Z",
    updated_at: "2021-02-23T07:56:50Z",
    pushed_at: "2021-01-24T15:20:58Z",
    git_url: "git://github.com/sdras/devex-utm-builder.git",
    ssh_url: "git@github.com:sdras/devex-utm-builder.git",
    clone_url: "https://github.com/sdras/devex-utm-builder.git",
    svn_url: "https://github.com/sdras/devex-utm-builder",
    homepage: "",
    size: 87,
    stargazers_count: 7,
    watchers_count: 7,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 4,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: "bsd-3-clause",
      name: 'BSD 3-Clause "New" or "Revised" License',
      spdx_id: "BSD-3-Clause",
      url: "https://api.github.com/licenses/bsd-3-clause",
      node_id: "MDc6TGljZW5zZTU=",
    },
    forks: 4,
    open_issues: 1,
    watchers: 7,
    default_branch: "main",
  },
  {
    id: 335819397,
    node_id: "MDEwOlJlcG9zaXRvcnkzMzU4MTkzOTc=",
    name: "docs-extensionpack",
    full_name: "sdras/docs-extensionpack",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/docs-extensionpack",
    description:
      "A collection of extensions for writing, editing, and reviewing documentation in VS Code",
    fork: false,
    url: "https://api.github.com/repos/sdras/docs-extensionpack",
    forks_url: "https://api.github.com/repos/sdras/docs-extensionpack/forks",
    keys_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/docs-extensionpack/teams",
    hooks_url: "https://api.github.com/repos/sdras/docs-extensionpack/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/docs-extensionpack/events",
    assignees_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/docs-extensionpack/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/docs-extensionpack/merges",
    archive_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/docs-extensionpack/deployments",
    created_at: "2021-02-04T02:49:06Z",
    updated_at: "2021-06-20T05:51:06Z",
    pushed_at: "2021-02-05T13:47:11Z",
    git_url: "git://github.com/sdras/docs-extensionpack.git",
    ssh_url: "git@github.com:sdras/docs-extensionpack.git",
    clone_url: "https://github.com/sdras/docs-extensionpack.git",
    svn_url: "https://github.com/sdras/docs-extensionpack",
    homepage: "",
    size: 45,
    stargazers_count: 53,
    watchers_count: 53,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 3,
    open_issues: 0,
    watchers: 53,
    default_branch: "master",
  },
  {
    id: 371223676,
    node_id: "MDEwOlJlcG9zaXRvcnkzNzEyMjM2NzY=",
    name: "docsv1",
    full_name: "sdras/docsv1",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/docsv1",
    description: "Docs for the V1 release",
    fork: true,
    url: "https://api.github.com/repos/sdras/docsv1",
    forks_url: "https://api.github.com/repos/sdras/docsv1/forks",
    keys_url: "https://api.github.com/repos/sdras/docsv1/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/docsv1/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/docsv1/teams",
    hooks_url: "https://api.github.com/repos/sdras/docsv1/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/docsv1/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/docsv1/events",
    assignees_url: "https://api.github.com/repos/sdras/docsv1/assignees{/user}",
    branches_url: "https://api.github.com/repos/sdras/docsv1/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/docsv1/tags",
    blobs_url: "https://api.github.com/repos/sdras/docsv1/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/sdras/docsv1/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/sdras/docsv1/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/sdras/docsv1/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/sdras/docsv1/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/docsv1/languages",
    stargazers_url: "https://api.github.com/repos/sdras/docsv1/stargazers",
    contributors_url: "https://api.github.com/repos/sdras/docsv1/contributors",
    subscribers_url: "https://api.github.com/repos/sdras/docsv1/subscribers",
    subscription_url: "https://api.github.com/repos/sdras/docsv1/subscription",
    commits_url: "https://api.github.com/repos/sdras/docsv1/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/docsv1/git/commits{/sha}",
    comments_url: "https://api.github.com/repos/sdras/docsv1/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/docsv1/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/sdras/docsv1/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/docsv1/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/docsv1/merges",
    archive_url:
      "https://api.github.com/repos/sdras/docsv1/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/docsv1/downloads",
    issues_url: "https://api.github.com/repos/sdras/docsv1/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/docsv1/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/docsv1/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/docsv1/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/docsv1/labels{/name}",
    releases_url: "https://api.github.com/repos/sdras/docsv1/releases{/id}",
    deployments_url: "https://api.github.com/repos/sdras/docsv1/deployments",
    created_at: "2021-05-27T02:29:04Z",
    updated_at: "2021-05-27T02:29:05Z",
    pushed_at: "2021-05-07T07:53:12Z",
    git_url: "git://github.com/sdras/docsv1.git",
    ssh_url: "git@github.com:sdras/docsv1.git",
    clone_url: "https://github.com/sdras/docsv1.git",
    svn_url: "https://github.com/sdras/docsv1",
    homepage: "https://wails.app",
    size: 50554,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 150484585,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTA0ODQ1ODU=",
    name: "durablefunctions-apiscraping-nodejs",
    full_name: "sdras/durablefunctions-apiscraping-nodejs",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/durablefunctions-apiscraping-nodejs",
    description:
      "Build an Azure Durable Functions that will scrape GitHub for opened issues and store them on Azure Storage.",
    fork: true,
    url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs",
    forks_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/forks",
    keys_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/teams",
    hooks_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/events",
    assignees_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/merges",
    archive_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/deployments",
    created_at: "2018-09-26T20:13:44Z",
    updated_at: "2018-09-26T20:13:46Z",
    pushed_at: "2018-09-28T23:53:12Z",
    git_url: "git://github.com/sdras/durablefunctions-apiscraping-nodejs.git",
    ssh_url: "git@github.com:sdras/durablefunctions-apiscraping-nodejs.git",
    clone_url:
      "https://github.com/sdras/durablefunctions-apiscraping-nodejs.git",
    svn_url: "https://github.com/sdras/durablefunctions-apiscraping-nodejs",
    homepage: null,
    size: 27,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 211209452,
    node_id: "MDEwOlJlcG9zaXRvcnkyMTEyMDk0NTI=",
    name: "easiest-netlify-lambda-example",
    full_name: "sdras/easiest-netlify-lambda-example",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/easiest-netlify-lambda-example",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/sdras/easiest-netlify-lambda-example",
    forks_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/forks",
    keys_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/teams",
    hooks_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/events",
    assignees_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/merges",
    archive_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/deployments",
    created_at: "2019-09-27T01:14:31Z",
    updated_at: "2021-03-18T22:46:12Z",
    pushed_at: "2019-09-27T01:47:24Z",
    git_url: "git://github.com/sdras/easiest-netlify-lambda-example.git",
    ssh_url: "git@github.com:sdras/easiest-netlify-lambda-example.git",
    clone_url: "https://github.com/sdras/easiest-netlify-lambda-example.git",
    svn_url: "https://github.com/sdras/easiest-netlify-lambda-example",
    homepage: null,
    size: 6,
    stargazers_count: 4,
    watchers_count: 4,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 0,
    open_issues: 0,
    watchers: 4,
    default_branch: "master",
  },
  {
    id: 195306388,
    node_id: "MDEwOlJlcG9zaXRvcnkxOTUzMDYzODg=",
    name: "ecommerce-netlify",
    full_name: "sdras/ecommerce-netlify",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/ecommerce-netlify",
    description:
      "🛍 A JAMstack Ecommerce Site built with Nuxt and Netlify Functions",
    fork: false,
    url: "https://api.github.com/repos/sdras/ecommerce-netlify",
    forks_url: "https://api.github.com/repos/sdras/ecommerce-netlify/forks",
    keys_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/ecommerce-netlify/teams",
    hooks_url: "https://api.github.com/repos/sdras/ecommerce-netlify/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/ecommerce-netlify/events",
    assignees_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/ecommerce-netlify/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/ecommerce-netlify/merges",
    archive_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/ecommerce-netlify/deployments",
    created_at: "2019-07-04T22:17:31Z",
    updated_at: "2021-07-22T16:32:07Z",
    pushed_at: "2021-06-16T07:28:12Z",
    git_url: "git://github.com/sdras/ecommerce-netlify.git",
    ssh_url: "git@github.com:sdras/ecommerce-netlify.git",
    clone_url: "https://github.com/sdras/ecommerce-netlify.git",
    svn_url: "https://github.com/sdras/ecommerce-netlify",
    homepage: "https://ecommerce-netlify.netlify.app/",
    size: 2030,
    stargazers_count: 1227,
    watchers_count: 1227,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 344,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 20,
    license: null,
    forks: 344,
    open_issues: 20,
    watchers: 1227,
    default_branch: "main",
  },
  {
    id: 153392539,
    node_id: "MDEwOlJlcG9zaXRvcnkxNTMzOTI1Mzk=",
    name: "example-azure-node",
    full_name: "sdras/example-azure-node",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/example-azure-node",
    description: "An example Node webapp deployed with GitHub actions",
    fork: false,
    url: "https://api.github.com/repos/sdras/example-azure-node",
    forks_url: "https://api.github.com/repos/sdras/example-azure-node/forks",
    keys_url:
      "https://api.github.com/repos/sdras/example-azure-node/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/example-azure-node/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/example-azure-node/teams",
    hooks_url: "https://api.github.com/repos/sdras/example-azure-node/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/example-azure-node/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/example-azure-node/events",
    assignees_url:
      "https://api.github.com/repos/sdras/example-azure-node/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/example-azure-node/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/example-azure-node/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/example-azure-node/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/example-azure-node/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/example-azure-node/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/example-azure-node/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/example-azure-node/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/example-azure-node/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/example-azure-node/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/example-azure-node/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/example-azure-node/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/example-azure-node/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/example-azure-node/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/example-azure-node/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/example-azure-node/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/example-azure-node/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/example-azure-node/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/example-azure-node/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/example-azure-node/merges",
    archive_url:
      "https://api.github.com/repos/sdras/example-azure-node/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/example-azure-node/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/example-azure-node/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/example-azure-node/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/example-azure-node/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/example-azure-node/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/example-azure-node/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/example-azure-node/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/example-azure-node/deployments",
    created_at: "2018-10-17T03:51:51Z",
    updated_at: "2021-04-19T14:43:50Z",
    pushed_at: "2019-08-28T15:16:42Z",
    git_url: "git://github.com/sdras/example-azure-node.git",
    ssh_url: "git@github.com:sdras/example-azure-node.git",
    clone_url: "https://github.com/sdras/example-azure-node.git",
    svn_url: "https://github.com/sdras/example-azure-node",
    homepage: null,
    size: 7,
    stargazers_count: 68,
    watchers_count: 68,
    language: "Shell",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 39,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 1,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 39,
    open_issues: 1,
    watchers: 68,
    default_branch: "master",
  },
  {
    id: 304960633,
    node_id: "MDEwOlJlcG9zaXRvcnkzMDQ5NjA2MzM=",
    name: "favegame",
    full_name: "sdras/favegame",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/favegame",
    description:
      "Small starter example of Hasura, Nuxt, and Netlify for Jamstack/SSR rendering",
    fork: false,
    url: "https://api.github.com/repos/sdras/favegame",
    forks_url: "https://api.github.com/repos/sdras/favegame/forks",
    keys_url: "https://api.github.com/repos/sdras/favegame/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/favegame/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/favegame/teams",
    hooks_url: "https://api.github.com/repos/sdras/favegame/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/favegame/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/favegame/events",
    assignees_url:
      "https://api.github.com/repos/sdras/favegame/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/favegame/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/favegame/tags",
    blobs_url: "https://api.github.com/repos/sdras/favegame/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/sdras/favegame/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/sdras/favegame/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/sdras/favegame/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/sdras/favegame/statuses/{sha}",
    languages_url: "https://api.github.com/repos/sdras/favegame/languages",
    stargazers_url: "https://api.github.com/repos/sdras/favegame/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/favegame/contributors",
    subscribers_url: "https://api.github.com/repos/sdras/favegame/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/favegame/subscription",
    commits_url: "https://api.github.com/repos/sdras/favegame/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/favegame/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/favegame/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/favegame/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/favegame/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/favegame/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/favegame/merges",
    archive_url:
      "https://api.github.com/repos/sdras/favegame/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/sdras/favegame/downloads",
    issues_url: "https://api.github.com/repos/sdras/favegame/issues{/number}",
    pulls_url: "https://api.github.com/repos/sdras/favegame/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/favegame/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/favegame/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/sdras/favegame/labels{/name}",
    releases_url: "https://api.github.com/repos/sdras/favegame/releases{/id}",
    deployments_url: "https://api.github.com/repos/sdras/favegame/deployments",
    created_at: "2020-10-17T20:08:42Z",
    updated_at: "2021-05-22T08:12:13Z",
    pushed_at: "2020-10-25T20:21:08Z",
    git_url: "git://github.com/sdras/favegame.git",
    ssh_url: "git@github.com:sdras/favegame.git",
    clone_url: "https://github.com/sdras/favegame.git",
    svn_url: "https://github.com/sdras/favegame",
    homepage: "https://hasura-nuxt-demo.netlify.app/",
    size: 675,
    stargazers_count: 41,
    watchers_count: 41,
    language: "Vue",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 4,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    forks: 4,
    open_issues: 0,
    watchers: 41,
    default_branch: "master",
  },
  {
    id: 120164392,
    node_id: "MDEwOlJlcG9zaXRvcnkxMjAxNjQzOTI=",
    name: "firefighter-demo",
    full_name: "sdras/firefighter-demo",
    private: false,
    owner: {
      login: "sdras",
      id: 2281088,
      node_id: "MDQ6VXNlcjIyODEwODg=",
      avatar_url: "https://avatars.githubusercontent.com/u/2281088?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/sdras",
      html_url: "https://github.com/sdras",
      followers_url: "https://api.github.com/users/sdras/followers",
      following_url:
        "https://api.github.com/users/sdras/following{/other_user}",
      gists_url: "https://api.github.com/users/sdras/gists{/gist_id}",
      starred_url: "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/sdras/subscriptions",
      organizations_url: "https://api.github.com/users/sdras/orgs",
      repos_url: "https://api.github.com/users/sdras/repos",
      events_url: "https://api.github.com/users/sdras/events{/privacy}",
      received_events_url: "https://api.github.com/users/sdras/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/sdras/firefighter-demo",
    description:
      "🚨 Demo to improve an existing firefighter app by making it queue tasks offline",
    fork: false,
    url: "https://api.github.com/repos/sdras/firefighter-demo",
    forks_url: "https://api.github.com/repos/sdras/firefighter-demo/forks",
    keys_url:
      "https://api.github.com/repos/sdras/firefighter-demo/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/sdras/firefighter-demo/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/sdras/firefighter-demo/teams",
    hooks_url: "https://api.github.com/repos/sdras/firefighter-demo/hooks",
    issue_events_url:
      "https://api.github.com/repos/sdras/firefighter-demo/issues/events{/number}",
    events_url: "https://api.github.com/repos/sdras/firefighter-demo/events",
    assignees_url:
      "https://api.github.com/repos/sdras/firefighter-demo/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/sdras/firefighter-demo/branches{/branch}",
    tags_url: "https://api.github.com/repos/sdras/firefighter-demo/tags",
    blobs_url:
      "https://api.github.com/repos/sdras/firefighter-demo/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/sdras/firefighter-demo/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/sdras/firefighter-demo/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/sdras/firefighter-demo/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/sdras/firefighter-demo/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/sdras/firefighter-demo/languages",
    stargazers_url:
      "https://api.github.com/repos/sdras/firefighter-demo/stargazers",
    contributors_url:
      "https://api.github.com/repos/sdras/firefighter-demo/contributors",
    subscribers_url:
      "https://api.github.com/repos/sdras/firefighter-demo/subscribers",
    subscription_url:
      "https://api.github.com/repos/sdras/firefighter-demo/subscription",
    commits_url:
      "https://api.github.com/repos/sdras/firefighter-demo/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/sdras/firefighter-demo/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/sdras/firefighter-demo/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/sdras/firefighter-demo/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/sdras/firefighter-demo/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/sdras/firefighter-demo/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/sdras/firefighter-demo/merges",
    archive_url:
      "https://api.github.com/repos/sdras/firefighter-demo/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/sdras/firefighter-demo/downloads",
    issues_url:
      "https://api.github.com/repos/sdras/firefighter-demo/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/sdras/firefighter-demo/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/sdras/firefighter-demo/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/sdras/firefighter-demo/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/sdras/firefighter-demo/labels{/name}",
    releases_url:
      "https://api.github.com/repos/sdras/firefighter-demo/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/sdras/firefighter-demo/deployments",
    created_at: "2018-02-04T07:29:17Z",
    updated_at: "2020-07-07T10:17:36Z",
    pushed_at: "2018-02-04T22:19:44Z",
    git_url: "git://github.com/sdras/firefighter-demo.git",
    ssh_url: "git@github.com:sdras/firefighter-demo.git",
    clone_url: "https://github.com/sdras/firefighter-demo.git",
    svn_url: "https://github.com/sdras/firefighter-demo",
    homepage: "https://sdras.github.io/firefighter-demo/",
    size: 13,
    stargazers_count: 66,
    watchers_count: 66,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 4,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: {
      key: "mit",
      name: "MIT License",
      spdx_id: "MIT",
      url: "https://api.github.com/licenses/mit",
      node_id: "MDc6TGljZW5zZTEz",
    },
    forks: 4,
    open_issues: 0,
    watchers: 66,
    default_branch: "master",
  },
];
// {"mode":"full","isActive":false}
